import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  public isLoggedIn: boolean = false;
  public server = environment.APIEndpoint;
  public authType = 'Bearer'
  public urls: any = {
    secureRecentOrders: this.server + 'api/order/v1/recent/orders',
    unsecureRecentOrders: this.server + 'api/unsec/order/v1/recent',
    secureMailOrder: this.server + 'api/order/notification/v1/send',
    unsecureMailOrder: this.server + 'api/unsec/order/notification/v1/send',
    orderStatusSecure : this.server + 'api/order/transaction/v1/status/get?orderId=',
    orderStatusUnSecure : this.server + 'api/unsec/order/transaction/v1/status/get?orderId=',
    gcOrderStatusUnSecure : this.server + 'api/order/unsec/msr/transaction/v1/status/get?orderId=',
    gcOrderStatusSecure : this.server + 'api/order/sec/msr/transaction/v1/status/get?orderId='
  };
  public deviceMetaInfo = {
    "appVersion":"",
    "deviceCountry":"India",
    "deviceCity":"",
    "deviceId":localStorage.getItem("deviceId"),
    "deviceModel":"",
    "platform":"WEB",
    "deviceOSVersion":""};
  public secHeaderData = {
    'Authorization': 'Bearer ' + this.storageService.getAccessToken(),
    'Accept-Language': 'EN',
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo),
  };
  public unsecHeaderData = {
    'Accept-Language': 'EN',
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo),
    'GuestToken': localStorage.getItem('guestUserToken'),
  };
  constructor(private http: HttpClient,private commonFunction: CommonFunctions,private storageService:StorageService, private apiHeader : ApiHeaderService) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  getRecentOdersList() {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if(isLoggedIn){
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.secureRecentOrders, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.unsecureRecentOrders, { headers: unsecureHeaders });
    }
  }
  sendMailOrderDetails(requestPayload) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if(this.isLoggedIn){
      return this.http.post(this.urls.secureMailOrder,requestPayload, { headers: this.secHeaderData });
    } else {
      return this.http.post(this.urls.unsecureMailOrder,requestPayload, { headers: this.unsecHeaderData });
    }
  }
  getOrderStatus(orderId) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if(isLoggedIn){
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.orderStatusSecure+orderId, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.orderStatusUnSecure+orderId, { headers: unsecureHeaders });
    }
  }
  gcOrderStatus(orderId) {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    if(isLoggedIn){
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.gcOrderStatusSecure+orderId, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.gcOrderStatusUnSecure+orderId, { headers: unsecureHeaders });
    }
  }
}
